import React, { useState, useEffect, useMemo } from "react";
import { Tooltip } from "@mui/material";
import { connect } from "react-redux";
import {
  Card,
  CardContent,
  Box,
  Typography,
  Divider,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  TextField,
  Checkbox,
  Grid,
  Paper,
  Select as MuiSelect,
} from "@mui/material";
import { Add as AddIcon, Close as CloseIcon } from "@mui/icons-material";
import SendInviteDialog from "../common/SendInviteDialog"; // Import the new component
import { Video, Users, Plus, X } from "lucide-react";
import { Link } from "react-router-dom";
import {
  sendInvite,
  addHrRemarks,
  getCandidatesByBatchId,
  releaseOffer,
  scheduleSecRound,
} from "../../redux/actions/candidate";
import { formatExperienceDuration } from "../../utils/helpers";
import FlagIcon from "@mui/icons-material/Flag";
// Import Material-UI icons
import SmartDisplayTwoToneIcon from "@mui/icons-material/SmartDisplayTwoTone";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import DownloadIcon from "@mui/icons-material/Download";
import BookIcon from "@mui/icons-material/Book";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import EditIcon from "@mui/icons-material/Edit";
import { styled } from "@mui/system";
import ServerPaginationGridNoRowCount from "../../components/Table/DataGrid";
import ViolationSliderModal from "../../components/modals/ViolationSliderModal";
import {
  getApplicantReport,
  viewApplicantReport,
} from "../../redux/actions/applicant";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { formatDate } from "../../utils/dateUtils";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AlertDialog from "../../components/Dialog";
import extractSortAndFilterParams from "../../components/Table/filterSortParams";
import {
  _addViolation,
  _removeViolation,
  _callaicandidate
} from "../../services/candidate.service";
import { _createRoom } from "../../services/meeting.service";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";

import MenuItem from "@mui/material/MenuItem";
import ReactSelect from 'react-select';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import countryList from 'react-select-country-list';
import { get_agent_without_pagination } from "../../services/agent.service";

const phoneCodes = {
  US: '+1',    // United States
  IN: '+91',   // India
  GB: '+44',   // United Kingdom
  FR: '+33',   // France
  DE: '+49',   // Germany
  // Gulf Countries
  AE: '+971',  // United Arab Emirates
  SA: '+966',  // Saudi Arabia
  QA: '+974',  // Qatar
  KW: '+965',  // Kuwait
  BH: '+973',  // Bahrain
  OM: '+968',  // Oman
  // Additional Countries
  CA: '+1',    // Canada
  AU: '+61',   // Australia
  JP: '+81',   // Japan
  CN: '+86',   // China
  RU: '+7',    // Russia
  BR: '+55',   // Brazil
  IT: '+39',   // Italy
  ES: '+34'    // Spain
};
const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
    box-sizing: border-box;
    width: 550px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 8px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 2px ${theme.palette.mode === "dark" ? grey[900] : grey[50]
    };

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? blue[600] : blue[200]
    };
    }

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);

// Custom styled components
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "16px",
    padding: theme.spacing(2),
    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: "#2c3e50",
  marginBottom: theme.spacing(2),
  display: "flex",
  alignItems: "center",
}));

const InterviewerCard = styled(Paper)(({ theme }) => ({
  background: "#ffffff",
  borderRadius: "12px",
  padding: theme.spacing(2),
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    boxShadow: theme.shadows[10],
    transform: "translateY(-2px)",
  },
}));

///

const CandidatesBatchComponent = ({
  getCandidatesByBatchId,
  candidates,
  sendInvite,
  addHrRemarks,
  releaseOffer,
  getApplicantReport,
  viewApplicantReport,
  scheduleSecRound,
  bT_ID,
  relaodData,
  setRelaodData,
  job_id,
}) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [showPopup, setShowPopup] = useState(false);
  const [showViolationPopup, setShowViolationPopup] = useState(false);
  const [showRemoveViolationPopup, setShowRemoveViolationPopup] =
    useState(false);
  const [showSendInviteModal, setShowSendInviteModal] = useState(false);
  const [showPopupRemark, setShowPopupRemark] = useState(false);
  const [remarkText, setRemarkText] = useState("");
  const [violationText, setViolationText] = useState("");
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [paginationModals, setPaginationModals] = useState({
    page: 0,
    pageSize: 50,
  });
  const [apctID, setApctID] = useState(null);
  const [violationApctID, setViolationApctID] = useState(null);
  const [remark, setRemark] = useState(null);
  const [showPopupSecRound, setShowPopupSecRound] = useState(false);
  const [secRoundApctId, setSecRoundApctId] = useState(null);
  const [email, setEmail] = useState(null);
  const [tableHeight, setTableHeight] = useState(400);
  const [mcqChecked, setMcqChecked] = useState(false);
  const [codeChecked, setCodeChecked] = useState(false);
  const [aiAssistanceCheck, setAiAssistanceCheck] = useState(true);
  const [emailContent, setEmailContent] = useState("");
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [mcqCount, setMcqCount] = useState(20);
  const [codeCount, setCodeCount] = useState(2);
  const [interviewCount, setInterviewCount] = useState(5);
  const [mcqError, setMcqError] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const [interviewError, setInterviewError] = useState(false);
  const [reschedule, setReshedule] = useState(false);
  const [contentRemove, setContentRemove] = useState("");
  const [confirmRemoveViolation, setConfirmRemoveViolation] = useState(false);
  // New state variables for time settings
  const [mcqTime, setMcqTime] = useState(15);
  const [codeTime, setCodeTime] = useState(15);
  const [aiInterviewTime, setAiInterviewTime] = useState(15);
  const [sortModels, setSortModels] = useState([]);
  const [emailSubject, setEmailSubject] = useState("");
  const [optionType, setOptionType] = useState("Standard");
  const [practicalOption, setPracticalOption] = useState("");
  const [interviewers, setInterviewers] = useState([{ email: "", name: "" }]);
  const [candidate, setCandidate] = useState({});
  const [interviewDateTime, setInterviewDateTime] = useState("");
  const [showBulkCallPopup, setShowBulkCallPopup] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [isMounted, setIsMounted] = useState(true);
  const [recaptchaReady, setRecaptchaReady] = useState(false);
  const [countryCode, setCountryCode] = useState(null); // Store selected country object
  const [selectedAgentId, setSelectedAgentId] = useState("default");
  const [allAgents, setAllAgents] = useState([]);
  // Prepare options for react-select
  const countryOptions = useMemo(() => {
    const countries = countryList().getData();
    console.log('Raw countries:', countries); // Debug: Check raw data
    const options = countries
      .map((country) => ({
        value: country.value, // ISO code (e.g., 'US')
        label: `${country.label} (${phoneCodes[country.value] || 'N/A'})`, // e.g., 'United States (+1)'
      }))
      .filter((country) => phoneCodes[country.value]); // Only include countries with phone codes
    console.log('Filtered options:', options); // Debug: Check filtered options
    return options;
  }, []);

  console.log("countryOptions", countryOptions);
  const addInterviewer = () => {
    setInterviewers([...interviewers, { email: "", name: "" }]);
  };

  const removeInterviewer = (index) => {
    if (interviewers.length > 1) {
      const newInterviewers = interviewers.filter((_, i) => i !== index);
      setInterviewers(newInterviewers);
    }
  };

  const updateInterviewer = (index, field, value) => {
    const newInterviewers = interviewers.map((interviewer, i) => {
      if (i === index) {
        return { ...interviewer, [field]: value };
      }
      return interviewer;
    });
    setInterviewers(newInterviewers);
  };

  const rowHeight = 52;
  const updateTableHeight = (pageSize) => {
    const headerHeight = 56; // Approximate header height (adjust based on your actual header height)
    const footerHeight = 56; // Approximate footer height (adjust based on your actual footer height)
    const newHeight = headerHeight + footerHeight + rowHeight * pageSize;
    setTableHeight(newHeight);
  };

  const handleSecondRound = (id) => {
    const candidateInfo = candidates.rows.find((row) => row.apct_id === id);
    console.log("candidate", candidateInfo);
    setSecRoundApctId(id);
    setCandidate(candidateInfo);
    // setSecRoundApctId(id);
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const [linkExpTime, setLinkExpTime] = useState(24);

  const handleLinkExpTimeChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 0) {
      setLinkExpTime(value);
    }
  };

  const handleSelectRow = (id) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((rowId) => rowId !== id); // Deselect row
      } else {
        return [...prev, id]; // Select row
      }
    });
  };

  // Select or deselect all rows
  const handleSelectAllRows = () => {
    setSelectedRows((prev) => {
      if (prev.length === candidates.rows.length) {
        return []; // Deselect all if already all are selected
      } else {
        return candidates.rows.map((row) => row.apct_id); // Select all rows
      }
    });
  };
  const handleViolationClick = (id) => {
    setViolationApctID(id);
    setShowViolationPopup(true);
  };

  const handleRemoveViolationClick = (id, name) => {
    setViolationApctID(id);
    setContentRemove(
      `Are you sure you want to remove violation of the applicant:  ${name}?`
    );
    setShowRemoveViolationPopup(true);
  };

  const [violationOpen, setViolationOpen] = useState(false);

  const [violationImages, setViolationImages] = useState([
    "https://via.placeholder.com/600x400?text=Image+1",
    "https://via.placeholder.com/600x400?text=Image+2",
    "https://via.placeholder.com/600x400?text=Image+3",
  ]);

  // Handlers for opening and closing the modal
  const handleViolationOpen = (images, id) => {
    setViolationImages(images);
    setViolationOpen(true);
  };
  const handleViolationClose = () => {
    setViolationOpen(false);
  };

  const handleInterviewCountChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setInterviewCount(value);
    if (value >= 5 && value <= 10) {
      setInterviewError(false);
    } else {
      setInterviewError(true);
    }
  };

  const columns = [
    // {
    //   field: "apct_btch_number",
    //   headerName: "Batch",
    //   width: 40,
    //   renderCell: (params) => (
    //     <Link to={`/hr/candidates?batchId=${params.row.apct_btch_id_fk}`}>
    //       {params.row.apct_btch_number}
    //     </Link>
    //   ),
    // },
    {
      field: "selection",
      headerName: "",
      width: 50,
      renderCell: (params) => (
        <Checkbox
          checked={selectedRows.includes(params.row.apct_id)}
          onChange={() => handleSelectRow(params.row.apct_id)}
        />
      ),
    },
    {
      field: "apct_name",
      headerName: "Name",
      flex: 1,
      minWidth: 250,

      renderCell: (params) => {
        const { apct_id, apct_name, apct_violation } = params.row;
        let flaggedReason;
        let multipleCount = 0;
        if (apct_violation.includes("reason")) {
          flaggedReason = JSON.parse(apct_violation).reason;
          multipleCount = JSON.parse(apct_violation).multiFace;
        }
        return (
          <Link to={`/hr/candidates/candidate-profile/${apct_id}`}>
            {apct_name}
            {(flaggedReason || multipleCount > 2) && (
              <>
                <FlagIcon
                  style={{ color: "red", marginLeft: "8px" }}
                  titleAccess="Flagged"
                />
                <Tooltip
                  title={
                    flaggedReason
                      ? flaggedReason
                      : multipleCount > 0
                        ? "Multiple face found"
                        : ""
                  }
                  placement="top"
                  arrow
                >
                  <span style={{ color: "red", marginLeft: "4px" }}>
                    Violated User
                  </span>
                </Tooltip>
              </>
            )}
          </Link>
        );
      },
    },
    {
      field: "apct_exp",
      headerName: "Experience",
      flex: 1,
      renderCell: (params) => {
        const { apct_exp, apct_exp_status } = params.row;
        return (
          <>
            <span>
              {formatExperienceDuration(apct_exp.length === 0 ? "0" : apct_exp)}
            </span>
            {apct_exp_status === false && (
              <FlagIcon
                style={{ color: "red", marginLeft: "8px" }}
                titleAccess="Flagged"
              />
            )}
          </>
        );
      },
    },
    {
      field: "apct_match_rate",
      headerName: "CV Match (%)",
      flex: 1,
      renderCell: (params) => (
        <>{params.row.apct_match_rate?.replace("%", "")}</>
      ), // Remove percentage sign
      sortComparator: (v1, v2) => {
        const val1 = parseFloat(v1.replace("%", "")); // Parse without "%", safer if renderCell already stripped it
        const val2 = parseFloat(v2.replace("%", ""));
        return val1 - val2;
      },
    },
    {
      field: "apct_int_url_sent",
      headerName: "Invite",
      flex: 1,
      renderCell: (params) => (
        <Button
          onClick={() =>
            params.row.apct_int_url_sent
              ? openResheduleSendInviteModal(params.row.apct_id)
              : openSendInviteModal(params.row.apct_id)
          }
        // disabled={params.row.apct_int_url_sent}
        >
          {params.row.apct_int_url_sent ? "Reschedule" : "Send"}
        </Button>
      ),
    },

    {
      field: "apct_email_opened",
      headerName: "Email Status",
      flex: 1,
      renderCell: ({ row: { apct_int_url_sent, apct_email_opened } }) =>
        apct_int_url_sent
          ? apct_email_opened
            ? "Email Opened"
            : "Email Sent"
          : "",
    },
    // {
    //   field: "ai_calling_score",
    //   headerName: "Ai Calling Score",
    //   flex: 1,
    //   renderCell: (params) =>
    //     params.row.apct_ai_calling_score ? (
    //       <Link to={`/hr/ai-calling-report/${params.row.apct_id}`}>
    //         {`${params.row.apct_ai_calling_score}/100`}
    //       </Link>
    //     ) : (
    //       "-"
    //     ),
    // },
    {
      field: "intw_rating",
      headerName: "Assistant Score",
      flex: 1,
      renderCell: (params) =>
        params.row.apct_intw_rating ? (
          <Link to={`/hr/ai_score/v2/${params.row.apct_id}`}>
            {`${params.row.apct_intw_rating}/10`}
          </Link>
        ) : (
          "-"
        ),
    },
    {
      field: "psycometric_score",
      headerName: "Psycometric Score",
      flex: 1,
      renderCell: (params) =>
        params.row.apct_psycometric_score ? (
          <Link to={`/hr/psychometric-report/${params.row.apct_id}`}>
            {`${params.row.apct_psycometric_score}/100`}
          </Link>
        ) : (
          "-"
        ),
    },
    {
      field: "apct_violation",
      headerName: "Violation Details",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const { apct_violation, violation_images, apct_id } = params.row;
        let flagged = apct_violation;

        try {
          if (
            typeof apct_violation === "string" &&
            apct_violation.includes("reason")
          ) {
            flagged = JSON.parse(apct_violation);
          }
        } catch (error) {
          console.error("Error parsing apct_violation:", error);
        }

        // if (flagged) return null;
        if (typeof flagged === "string") return null;
        // Prepare tooltip content
        const tooltipContent = (
          <div>
            {flagged.noFace >= 0 && <div>No Face: {flagged.noFace}</div>}
            {flagged.multiFace >= 0 && (
              <div>Multiple Faces: {flagged.multiFace}</div>
            )}
            {flagged.lookingAway >= 0 && (
              <div>Looking Away: {flagged.lookingAway}</div>
            )}
          </div>
        );

        const handleClick = () => {
          if (violation_images?.length > 0) {
            handleViolationOpen(violation_images, apct_id);
          }
        };

        return (
          <Tooltip title={tooltipContent} placement="top" arrow>
            <span
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={handleClick}
            >
              View Details
            </span>
          </Tooltip>
        );
      },
    },
    // {
    //   field: "apct_second_round",
    //   headerName: "2nd Round",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <Button onClick={() => handleSecondRound(params.row.apct_id)}>
    //       {params.row.apct_second_round ? "Scheduled" : "Schedule"}
    //     </Button>
    //   ),
    // },
    {
      field: "apct_hr_remarks",
      headerName: "Remark",
      flex: 1,
      renderCell: (params) => (
        <Button
          onClick={
            params.row.apct_hr_remarks
              ? () => setRemark(params.row.apct_hr_remarks)
              : () => setApctID(params.row.apct_id)
          }
        >
          {params.row.apct_hr_remarks ? "View" : "Add"}
        </Button>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <>
          {params.row.apct_stage === "completed" ||
            params.row.apct_stage === "Partial" ? (
            <Link
              to={`/hr/candidates/interview-details/${params.row.apct_user_id_fk}/${params.row.apct_int_thread_id}`}
            >
              <IconButton sx={{ color: "#f70000" }}>
                <SmartDisplayTwoToneIcon />
              </IconButton>
            </Link>
          ) : (
            <IconButton disabled>
              <SmartDisplayTwoToneIcon />
            </IconButton>
          )}
          <IconButton
            disabled={!params.row.apct_intw_rating}
            onClick={() => setApctID(params.row.apct_id)}
          >
            <VolumeUpIcon />
          </IconButton>
          <IconButton
            disabled={!params.row.apct_intw_rating}
            onClick={() => viewApplicantReport(params.row.apct_id)}
          >
            <SpeakerNotesIcon />
          </IconButton>
          <IconButton
            disabled={!params.row.apct_intw_rating}
            onClick={() => getApplicantReport(params.row.apct_id)}
          >
            <DownloadIcon />
          </IconButton>
        </>
      ),
    },
    {
      field: "violation_actions",
      headerName: "Violation",
      flex: 1,
      renderCell: (params) => {
        const { apct_violation } = params.row;
        let flaggedReason;
        if (apct_violation.includes("reason")) {
          flaggedReason = JSON.parse(apct_violation).reason;
        }
        return (
          <>
            <IconButton
              onClick={() =>
                flaggedReason
                  ? handleRemoveViolationClick(
                    params.row.apct_id,
                    params.row.apct_name
                  )
                  : handleViolationClick(params.row.apct_id)
              }
            >
              <BookIcon style={{ color: flaggedReason ? "red" : "inherit" }} />
            </IconButton>
          </>
        );
      },
    },
    // {
    //   field: "apct_offer_released",
    //   headerName: "Offer",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <>
    //       <Button
    //         onClick={() => offerReleased(params.row.apct_id)}
    //         disabled={params.row.apct_offer_released}
    //       >
    //         {params.row.apct_offer_released ? "Released" : "Release"}
    //       </Button>
    //     </>
    //   ),
    // },
    {
      field: "apct_created_at",
      headerName: "Created At",
      flex: 1,
      renderCell: (params) => (
        <>
          {params && params.row && params.row.apct_created_at
            ? formatDate(
              JSON.parse(localStorage.getItem("user")),
              params.row.apct_created_at
            )
            : ""}
        </>
      ),
    },
    {
      field: "Edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => (
        <Button
          component={Link}
          to={`/hr/candidates/candidate-profile/${params.row.apct_id}?edit=true`}
          variant="text"
          color="primary"
          size={"small"}
        >
          <EditIcon />
        </Button>
      ),
    },
  ];

  useEffect(() => {
    if (remark) {
      setShowPopupRemark(true);
    }
  }, [remark]);

  useEffect(() => {
    if (apctID) {
      setShowPopup(true);
    }
  }, [apctID]);

  useEffect(() => {
    if (secRoundApctId) {
      setShowPopupSecRound(true);
    }
  }, [secRoundApctId]);

  const scheduleSecondRound = async () => {
    // await scheduleSecRound({
    //   apct_id: secRoundApctId,
    //   email: email,
    // });
    const response = await _createRoom({
      interviewers,
      candidate,
      interviewDateTime,
      job_id,
    });
    if (response.status === 200) {
      setSecRoundApctId(null);
      setEmail(null);
      setShowPopupSecRound(false);
    }
  };

  const onCancelSchedule = () => {
    setSecRoundApctId(null);
    setEmail(null);
    setShowPopupSecRound(false);
  };

  useEffect(() => {
    if (bT_ID) {
      const { sort, filters } = extractSortAndFilterParams(sortModels, []);
      getCandidatesByBatchId(
        bT_ID,
        paginationModals.page,
        paginationModals.pageSize,
        sort.field,
        sort.sort
      );
    }
  }, [bT_ID, paginationModals, sortModels]);

  useEffect(() => {
    if (relaodData) {
      const { sort, filters } = extractSortAndFilterParams(sortModels, []);
      getCandidatesByBatchId(
        bT_ID,
        paginationModals.page,
        paginationModals.pageSize,
        sort.field,
        sort.sort
      );
    }
  }, [relaodData]);

  const openSendInviteModal = (candidateId) => {
    setMcqChecked(false);
    setCodeChecked(false);
    // setEmailContent(`<p>Hi {{userName}},</p>
    //             <p>You have been invited for an AI Interview for the position of {{jobName}}.</p>
    //             <p>Please find below details:</p>
    //             <p>Username: {{userEmail}}</p>
    //             <p>Password: {{userPassword}}</p>
    //             <p>Please click on below link to start interview</p>
    //             <a href="{{link}}" target="_blank">Click Here</a>
    //             <div>Thank you</div>
    //             <div>Team</div>
    //             <div>Girikon</div>`);

    setEmailContent(` <p>Dear {{userName}},</p>
      <p>We are delighted to invite you to participate in the next round of our recruitment process for the position of <strong>{{jobName}}</strong>. As part of our selection process, you will be completing an interview assessment on an AI-powered platform.</p>
      <p><strong>Your Interview Details:</strong></p>
      <ul>
          <li><strong>Access the interview platform using the link below:</strong> <a href="{{link}}" target="_blank">Click Here</a></li>
          <li><strong>Username:</strong> {{userEmail}}</li>
          <li><strong>Password:</strong> {{userPassword}}</li>
      </ul>
      <p><strong>How to Proceed:</strong></p>
      <ol>
          <li>Use the link above to enter the interview platform.</li>
          <li>Log in with the username and password specified above.</li>
          <li>After logging in, grant consent to allow camera and microphone access.</li>
          <li>Questions will be shared on the screen, and you can answer them once the narration of the question stops.</li>
      </ol>
      <p>For the best experience, please take the interview in a quiet area with a reliable internet connection.</p>
      <p>The Interview link will expire 30 minutes after the mail is received.</p>
      <p>Regards</p>
      <p><strong>Human Resources Department</strong></p>
      `);
    setSelectedCandidateId(candidateId);
    setShowSendInviteModal(true);
  };

  const openResheduleSendInviteModal = (candidateId) => {
    // console.log("Reshedule======>");
    setReshedule(true);
    setMcqChecked(false);
    setCodeChecked(false);
    // setEmailContent(`<p>Hi {{userName}},</p>
    //             <p>You have been invited for an AI Interview for the position of {{jobName}}.</p>
    //             <p>Please find below details:</p>
    //             <p>Username: {{userEmail}}</p>
    //             <p>Password: {{userPassword}}</p>
    //             <p>Please click on below link to start interview</p>
    //             <a href="{{link}}" target="_blank">Click Here</a>
    //             <div>Thank you</div>
    //             <div>Team</div>
    //             <div>Girikon</div>`);

    setEmailContent(` <p>Dear {{userName}},</p>
      <p>We are delighted to invite you to participate in the next round of our recruitment process for the position of <strong>{{jobName}}</strong>. As part of our selection process, you will be completing an interview assessment on an AI-powered platform.</p>
      <p><strong>Your Interview Details:</strong></p>
      <ul>
          <li><strong>Access the interview platform using the link below:</strong> <a href="{{link}}" target="_blank">Click Here</a></li>
          <li><strong>Username:</strong> {{userEmail}}</li>
          <li><strong>Password:</strong> {{userPassword}}</li>
      </ul>
      <p><strong>How to Proceed:</strong></p>
      <ol>
          <li>Use the link above to enter the interview platform.</li>
          <li>Log in with the username and password specified above.</li>
          <li>After logging in, grant consent to allow camera and microphone access.</li>
          <li>Questions will be shared on the screen, and you can answer them once the narration of the question stops.</li>
      </ol>
      <p>For the best experience, please take the interview in a quiet area with a reliable internet connection.</p>
      <p>The Interview link will expire 30 minutes after the mail is received.</p>
      <p>Regards</p>
      <p><strong>Human Resources Department</strong></p>
      `);
    setSelectedCandidateId(candidateId);
    setShowSendInviteModal(true);
  };

  const handleCloseSendInviteModal = () => {
    setShowSendInviteModal(false);
    setSelectedCandidateId(null);
  };

  const handleRemarkSubmit = (apct_id) => {
    let data = {
      hr_remarks: remarkText,
      apct_id: apct_id,
    };
    addHrRemarks(
      data,
      null,
      bT_ID,
      paginationModals.page,
      paginationModals.pageSize
    );
    setShowPopup(false);
    setApctID(null);
  };

  const handleViolationReasonSubmit = async (apct_id) => {
    let data = {
      reason: violationText,
      apct_id: apct_id,
    };
    await _addViolation(data);
    setShowViolationPopup(false);
    setViolationApctID(null);
    setRelaodData(true);
  };

  const onClickCloseRemark = () => {
    setApctID(null);
    setShowPopup(false);
    setRemark(null);
  };

  const onClickCloseViolationReason = () => {
    setApctID(null);
    setShowViolationPopup(false);
    setViolationText(null);
  };

  const offerReleased = (apct_id) => {
    releaseOffer(
      apct_id,
      null,
      bT_ID,
      paginationModals.page,
      paginationModals.pageSize
    );
  };

  const openConfirmationDialog = () => {
    setShowConfirmationDialog(true);
  };

  const closeConfirmationDialog = () => {
    setShowConfirmationDialog(false);
  };

  const confirmAndSendInvite = (agent_id, questionSet_id, selectedLanguage) => {
    // sendInviteCandidate(params.row.apct_id);
    let bodyData = {
      mcq: mcqChecked,
      coding: codeChecked,
      interview: aiAssistanceCheck,
      email_body: emailContent,
      email_subject: emailSubject,
      mcqCount: mcqCount,
      codeCount: codeCount,
      interviewCount: interviewCount,
      mcqTime: mcqTime,
      codeTime: codeTime,
      aiInterviewTime: aiInterviewTime,
      reschedule: reschedule,
      linkExpTime: linkExpTime,
      optionType: optionType,
      practicalOption: practicalOption,
      agent_id: agent_id,
      questionSet_id: questionSet_id,
      interview_language: selectedLanguage,
    };
    sendInvite(
      selectedCandidateId,
      null,
      bT_ID,
      paginationModals.page,
      paginationModals.pageSize,
      bodyData
    );
    setShowConfirmationDialog(false);
    setShowSendInviteModal(false);
    setSelectedCandidateId(null);
  };

  useEffect(() => {
    updateTableHeight(candidates?.rows?.length);
  }, [paginationModals.pageSize, candidates]);

  // Validation handlers
  const handleMcqCountChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setMcqCount(value);
    if (value % 5 === 0 && value >= 10 && value <= 100) {
      setMcqError(false);
    } else {
      setMcqError(true);
    }
  };

  const handleCodeCountChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setCodeCount(value);
    if (value >= 2 && value <= 10) {
      setCodeError(false);
    } else {
      setCodeError(true);
    }
  };

  // Validation handlers for time settings
  const handleMcqTimeChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 0) {
      setMcqTime(value);
    }
  };

  const handleCodeTimeChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 0) {
      setCodeTime(value);
    }
  };

  const handleAiInterviewTimeChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 0) {
      setAiInterviewTime(value);
    }
  };
  const submitRemoveViolation = async () => {
    const data = {
      apct_id: violationApctID,
    };
    await _removeViolation(data);
    setShowRemoveViolationPopup(false);
    setViolationApctID(null);
    setRelaodData(true);
  };

  useEffect(() => {
    if (confirmRemoveViolation) {
      submitRemoveViolation();
    }
  }, [confirmRemoveViolation]);

  const deselectAllRows = () => {
    setSelectedRows([]);
  };

  useEffect(() => {
    setIsMounted(true);
    // Wait for reCAPTCHA to be ready
    const checkRecaptcha = () => {
      if (executeRecaptcha) {
        setRecaptchaReady(true);
      } else {
        setTimeout(checkRecaptcha, 100);
      }
    };
    checkRecaptcha();

    return () => {
      setIsMounted(false);
    };
  }, [executeRecaptcha]);

  const handleBulkCall = async (event) => {
    // event.preventDefault();

    if (!recaptchaReady || !executeRecaptcha) {
      console.error("reCAPTCHA not ready yet");
      return;
    }

    try {
      console.log("Initiating bulk call for candidates:", selectedRows);
      console.log("Agent:", selectedAgent);
      console.log("Language:", selectedLanguage);
      console.log("Country Code:", countryCode);
      console.log("Country Code:", phoneCodes[countryCode]);
      const selectedAgentRow = allAgents.find(
        (agent) => agent.agent_id === selectedAgent
      );
      console.log("Selected Agent Row:", selectedAgentRow);
      let recaptchaToken;
      try {
        recaptchaToken = await executeRecaptcha("make_call");
        console.log("reCAPTCHA token obtained:", recaptchaToken);
      } catch (recaptchaError) {
        console.error("reCAPTCHA execution failed:", recaptchaError);
        throw new Error("reCAPTCHA verification failed");
      }

      if (!recaptchaToken) {
        throw new Error("No reCAPTCHA token received");
      }

      console.log("selected agent", selectedAgentRow?.agent_summary);

      const combinedAgentString = [
        selectedAgentRow?.agent_summary || '',
        selectedAgentRow?.agent_dont || '',
        selectedAgentRow?.agent_dos || '',
        selectedAgentRow?.agent_extra || '',
        selectedAgentRow?.agent_guide_rails || ''
      ].filter(Boolean).join(' ');
      const reqData = {
        condidateIds: selectedRows,
        agentId: combinedAgentString,
        recaptchaToken: recaptchaToken,
        initialPrompt: "Hi there!",
        language: selectedLanguage,
        time_duration: 3000,
        countryCode: countryCode ? phoneCodes[countryCode] : null,
      };

      console.log("Request Data:", reqData);

      const response = await _callaicandidate(reqData);

      if (isMounted) {
        if (response && response.status === 200) {
          console.log("Bulk call successful:", response.data);
          setShowBulkCallPopup(false);
          setSelectedAgent("");
          setSelectedLanguage("");
        } else {
          console.warn("Unexpected response:", response);
        }
      }
    } catch (error) {
      if (isMounted) {
        console.error("Error in bulk call process:", error.message, error.stack);
      }
    }
  };

  const handleStartCallsClick = (event) => {
    handleBulkCall(event)
      .catch((error) => {
        console.error("Caught error from handleBulkCall:", error);
      });
  };

  // Handle dialog close with proper focus management
  const handleCloseBulkCallPopup = () => {
    setShowBulkCallPopup(false);
    setSelectedAgent("");
    setSelectedLanguage("");
    // Return focus to the triggering button
    document.querySelector("#bulk-call-button")?.focus();
  };

  const getAllAgents = async () => {
    const result = await get_agent_without_pagination();
    if (result?.status === 200) {
      const defaultAgent = {
        agent_id: "default", agent_name: "Default Agent", agent_dont: "",
        agent_dos: "",
        agent_extra: null,
        agent_guide_rails: "",
        agent_summary: `You are an AI-powered interview agent designed to conduct a preliminary interview with candidates. Your goal is to ask basic, conversational questions to assess a candidate’s background, experience, and general fit for a role. Maintain a friendly, professional tone and adapt your questions based on the candidate’s responses. Avoid overly technical or role-specific questions unless provided with additional context about the job.

        Start by introducing yourself briefly and explaining your purpose. Then, ask the following types of questions in a natural flow, pausing to allow the candidate to respond before proceeding to the next question:

        1. Can you please tell me a bit about yourself?
        2. How much experience do you have in your field or industry?
        3. What’s one of your proudest achievements in your career so far?
        4. Why are you interested in this opportunity?
        5. How do you handle working under pressure or tight deadlines?
        6. What skills do you think you bring to the table?
        7. Do you have any questions for me about the role or process?

        Feel free to follow up on their answers with light, relevant follow-up questions (e.g., “Can you tell me more about that?” or “How did you handle that situation?”) to keep the conversation engaging. If the candidate’s response is vague, politely ask for clarification (e.g., “Could you give me an example of what you mean?”).

        Keep track of their answers internally to summarize key points at the end (e.g., “Thanks for chatting with me! Based on what you’ve shared, it sounds like you have X years of experience and are passionate about Y.”). Do not ask sensitive personal questions (e.g., age, marital status) or make judgments about their suitability—focus on gathering information.

        If the candidate asks you a question, respond helpfully with general information (e.g., “I’m not sure about the exact details, but I can tell you this is an opportunity to grow your skills in [field]”) or defer if needed (e.g., “That’s a great question for the hiring manager in the next round!”).

        Begin the interview now.
      ` };
      const agentsWithDefault = [defaultAgent, ...result.data.agents];
      console.log("agentsWithDefault", agentsWithDefault);
      setAllAgents(agentsWithDefault);
      setSelectedAgentId(defaultAgent?.agent_id);
      setSelectedAgent(defaultAgent);
    } else {
      console.log(result?.data?.error || "Failed to fetch agents!");
    }
  };

  useEffect(() => {
    getAllAgents();
  }, []);

  return (
    <>
      <Card raised sx={{ minWidth: "100%" }}>
        <CardContent>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" sx={{ mt: 2 }}>
              Candidates{" "}
              <Button
                variant="text"
                size={"small"}
                color="primary"
                onClick={() =>
                  selectedRows.length === candidates?.rows.length
                    ? deselectAllRows()
                    : handleSelectAllRows()
                }
              >
                {selectedRows.length === candidates?.rows.length
                  ? "Deselect All"
                  : "Select All"}
              </Button>
            </Typography>

            {/* <Button
              variant="text"
              size={"small"}
              color="primary"
              disabled={selectedRows.length === 0}
              onClick={() => setShowBulkCallPopup(true)}
            >
              Bulk Calling
            </Button> */}
            <Button
              variant="text"
              size={"small"}
              color="primary"
              disabled={selectedRows.length <= 0}
              onClick={() => openSendInviteModal(selectedRows)}
            >
              Send Bulk Invite
            </Button>
          </Box>

          <Divider />
          <Dialog
            open={showBulkCallPopup}
            onClose={handleCloseBulkCallPopup}
            fullWidth
            maxWidth="sm"
            aria-labelledby="bulk-call-dialog-title"
            disableRestoreFocus
          >
            <DialogTitle id="bulk-call-dialog-title">
              Bulk Call Setup
            </DialogTitle>
            <DialogContent>
              <Box sx={{ mt: 2 }}>
                {/* Enhanced Agent Dropdown with Filter */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Autocomplete
                    options={allAgents.map(agent => ({
                      label: agent.agent_name,
                      value: agent.agent_id
                    }))}
                    getOptionLabel={(option) => option.label}
                    value={
                      selectedAgent
                        ? allAgents
                          .map(agent => ({ label: agent.agent_name, value: agent.agent_id }))
                          .find(option => option.value === selectedAgent) || null
                        : null
                    }
                    onChange={(event, newValue) => {
                      setSelectedAgent(newValue ? newValue.value : '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Agent"
                        variant="outlined"
                        placeholder="Search agents..."
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.label}
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) =>
                      options.filter(option =>
                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                      )
                    }
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                      },
                    }}
                  />
                </FormControl>

                {/* Enhanced Language Dropdown */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Autocomplete
                    options={[
                      { label: 'English', value: 'english' },
                      { label: 'Spanish', value: 'spanish' },
                      { label: 'French', value: 'french' },
                      { label: 'Arabic', value: 'arabic' },
                      { label: 'German', value: 'german' },
                      { label: 'Chinese (Mandarin)', value: 'chinese_mandarin' },
                      { label: 'Hindi', value: 'hindi' },
                      { label: 'Portuguese', value: 'portuguese' },
                      { label: 'Russian', value: 'russian' },
                      { label: 'Japanese', value: 'japanese' },
                      { label: 'Italian', value: 'italian' },
                      { label: 'Korean', value: 'korean' },
                      { label: 'Turkish', value: 'turkish' },
                      { label: 'Dutch', value: 'dutch' },
                      { label: 'Bengali', value: 'bengali' }
                    ]}
                    getOptionLabel={(option) => option.label}
                    value={
                      selectedLanguage
                        ? {
                          label: selectedLanguage
                            .replace(/_/g, ' ')
                            .replace(/\b\w/g, l => l.toUpperCase()),
                          value: selectedLanguage
                        }
                        : null
                    }
                    onChange={(event, newValue) => {
                      setSelectedLanguage(newValue ? newValue.value : '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Language"
                        variant="outlined"
                        placeholder="Search languages..."
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.label}
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) =>
                      options.filter(option =>
                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                      )
                    }
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                      },
                    }}
                  />
                </FormControl>

                {/* Enhanced Country Code Dropdown */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <Autocomplete
                    options={Object.entries(phoneCodes).map(([code, phone]) => ({
                      label: `${code} (${phone})`,
                      value: code
                    }))}
                    getOptionLabel={(option) => option.label}
                    value={
                      countryCode
                        ? {
                          label: `${countryCode} (${phoneCodes[countryCode]})`,
                          value: countryCode
                        }
                        : null
                    }
                    onChange={(event, newValue) => {
                      setCountryCode(newValue ? newValue.value : '');
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Country Code"
                        variant="outlined"
                        placeholder="Search country codes..."
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {option.label}
                      </li>
                    )}
                    filterOptions={(options, { inputValue }) =>
                      options.filter(option =>
                        option.label.toLowerCase().includes(inputValue.toLowerCase())
                      )
                    }
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                        height: '56px', // Match original ReactSelect height
                      },
                    }}
                  />
                </FormControl>
              </Box>
              {!recaptchaReady && (
                <Typography color="warning.main">
                  Loading reCAPTCHA verification...
                </Typography>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseBulkCallPopup}
                aria-label="Cancel bulk call setup"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleStartCallsClick({
                  selectedAgent,
                  selectedLanguage,
                  countryCode: countryCode ? phoneCodes[countryCode] : null
                })}
                color="primary"
                disabled={!selectedAgent || !selectedLanguage || !countryCode || !recaptchaReady}
                aria-label="Start bulk calls"
              >
                Start Calls
              </Button>
            </DialogActions>
          </Dialog>

          {/* Use the new SendInviteDialog component */}
          <SendInviteDialog
            open={showSendInviteModal}
            handleClose={handleCloseSendInviteModal}
            confirmAndSendInvite={confirmAndSendInvite}
            openConfirmationDialog={openConfirmationDialog}
            closeConfirmationDialog={closeConfirmationDialog}
            mcqChecked={mcqChecked}
            setMcqChecked={setMcqChecked}
            codeChecked={codeChecked}
            setCodeChecked={setCodeChecked}
            aiAssistanceCheck={aiAssistanceCheck}
            setAiAssistanceCheck={setAiAssistanceCheck}
            emailContent={emailContent}
            setEmailContent={setEmailContent}
            setEmailSubject={setEmailSubject}
            mcqCount={mcqCount}
            handleMcqCountChange={handleMcqCountChange}
            mcqError={mcqError}
            codeCount={codeCount}
            handleCodeCountChange={handleCodeCountChange}
            codeError={codeError}
            interviewError={interviewError}
            mcqTime={mcqTime}
            handleMcqTimeChange={handleMcqTimeChange}
            codeTime={codeTime}
            handleCodeTimeChange={handleCodeTimeChange}
            aiInterviewTime={aiInterviewTime}
            linkExpTime={linkExpTime}
            handleAiInterviewTimeChange={handleAiInterviewTimeChange}
            handleLinkExpTimeChange={handleLinkExpTimeChange}
            showConfirmationDialog={showConfirmationDialog}
            reschedule={reschedule}
            optionType={optionType}
            setOptionType={setOptionType}
            setPracticalOption={setPracticalOption}
            practicalOption={practicalOption}
            interviewCount={interviewCount}
            handleInterviewCountChange={handleInterviewCountChange}
            job_id={job_id}
          />
          {/* <Dialog
            open={showPopupSecRound}
            onClose={() => onCancelSchedule()}
            fullWidth
            maxWidth="lg"
          >
            <DialogTitle>Schedule Second Round</DialogTitle>
            <DialogContent>
             
              <div style={{ marginBottom: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Users className="h-5 w-5" style={{ marginRight: "8px" }} />
                    Interviewers
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={addInterviewer}
                  >
                    Add Interviewer
                  </Button>
                </div>

                {interviewers.map(({ name, email }, index) => (
                  <Paper key={index} sx={{ p: 2, mt: 1, position: "relative" }}>
                    {interviewers.length > 1 && (
                      <IconButton
                        sx={{ position: "absolute", top: 8, right: 8 }}
                        onClick={() => removeInterviewer(index)}
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                    <Grid container spacing={2}>
                      {[
                        { label: "Name", value: name, key: "name" },
                        { label: "Email", value: email, key: "email" },
                      ].map(({ label, value, key }) => (
                        <Grid item xs={12} sm={5} key={key}>
                          <TextField
                            label={label}
                            variant="outlined"
                            fullWidth
                            required
                            value={value}
                            onChange={(e) =>
                              updateInterviewer(index, key, e.target.value)
                            }
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                ))}
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => onCancelSchedule()}>Cancel</Button>
              <Button
                onClick={() => scheduleSecondRound()}
                color="primary"
              >
                Schedule
              </Button>
            </DialogActions>
          </Dialog> */}

          <StyledDialog
            open={showPopupSecRound}
            onClose={() => onCancelSchedule()}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle
              sx={{
                textAlign: "center",
                color: "#ffffff",
                background: "linear-gradient(90deg, #3498db 0%, #2980b9 100%)",
                borderRadius: "12px 12px 0 0",
                padding: "16px",
              }}
            >
              Schedule Second Round
            </DialogTitle>
            <DialogContent sx={{ padding: "24px" }}>
              {/* Date and Time Picker Section */}
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  background: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: 1,
                }}
              >
                <SectionTitle variant="h6">
                  <CalendarTodayIcon sx={{ color: "#3498db", mr: 1 }} />
                  Interview Schedule
                </SectionTitle>
                <TextField
                  label="Interview Date & Time"
                  type="datetime-local"
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ min: new Date().toISOString().slice(0, 16) }}
                  value={interviewDateTime}
                  onChange={(e) => setInterviewDateTime(e.target.value)}
                  sx={{
                    mt: 1,
                    "& .MuiOutlinedInput-root": { borderRadius: "8px" },
                  }}
                />
              </Box>

              {/* Interviewers Section */}
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  background: "#ffffff",
                  borderRadius: "12px",
                  boxShadow: 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <SectionTitle variant="h6">
                    <Users
                      color="#3498db"
                      size={20}
                      style={{ marginRight: "8px" }}
                    />
                    Interviewers
                  </SectionTitle>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={addInterviewer}
                    size="small"
                    sx={{
                      background: "#3498db",
                      "&:hover": { background: "#2980b9" },
                    }}
                  >
                    Add Interviewer
                  </Button>
                </div>

                {interviewers.map(({ name, email }, index) => (
                  <InterviewerCard key={index} elevation={2}>
                    {interviewers.length > 1 && (
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 2,
                          right: 4,
                          color: "#7f8c8d",
                        }}
                        onClick={() => removeInterviewer(index)}
                        size="small"
                      >
                        <CloseIcon />
                      </IconButton>
                    )}
                    <Grid container spacing={2} alignItems="center">
                      {[
                        { label: "Name", value: name, key: "name" },
                        { label: "Email", value: email, key: "email" },
                      ].map(({ label, value, key }) => (
                        <Grid item xs={12} sm={12} key={key}>
                          <TextField
                            label={label}
                            variant="outlined"
                            required
                            value={value}
                            onChange={(e) =>
                              updateInterviewer(index, key, e.target.value)
                            }
                            size="small"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                              },
                            }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </InterviewerCard>
                ))}
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
              <Button
                onClick={() => onCancelSchedule()}
                variant="outlined"
                sx={{
                  minWidth: 120,
                  color: "#e74c3c",
                  borderColor: "#e74c3c",
                  "&:hover": { background: "#f2dede", borderColor: "#e74c3c" },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={() => scheduleSecondRound()}
                color="primary"
                variant="contained"
                sx={{
                  minWidth: 120,
                  background: "#2ecc71",
                  "&:hover": { background: "#27ae60" },
                }}
              >
                Schedule
              </Button>
            </DialogActions>
          </StyledDialog>

          <Dialog
            open={showPopup}
            onClose={() => setShowPopup(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Add Remark</DialogTitle>
            <DialogContent>
              <Textarea
                minRows={4}
                autoFocus
                fullWidth
                minWidth="sm"
                value={remarkText}
                onChange={(e) => setRemarkText(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => onClickCloseRemark()}>Cancel</Button>
              <Button
                onClick={() => handleRemarkSubmit(apctID)}
                color="primary"
                disabled={!remarkText}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={showViolationPopup}
            onClose={() => setShowViolationPopup(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>Add Violation Reason</DialogTitle>
            <DialogContent>
              <Textarea
                minRows={4}
                autoFocus
                fullWidth
                minWidth="sm"
                value={violationText}
                onChange={(e) => setViolationText(e.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => onClickCloseViolationReason()}>
                Cancel
              </Button>
              <Button
                onClick={() => handleViolationReasonSubmit(violationApctID)}
                color="primary"
                disabled={!violationText}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog
            open={showPopupRemark}
            onClose={() => setShowPopupRemark(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>View Remark</DialogTitle>
            <DialogContent>
              <Typography>{remark}</Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowPopupRemark(false)}>Okay</Button>
            </DialogActions>
          </Dialog>

          <ViolationSliderModal
            images={violationImages}
            open={violationOpen}
            onClose={handleViolationClose}
            setViolationOpen={setViolationOpen}
          />

          <AlertDialog
            open={showRemoveViolationPopup}
            setOpen={setShowRemoveViolationPopup}
            title={"Remove Violation"}
            setConfirm={setConfirmRemoveViolation}
            content={contentRemove}
          />
          <div style={{ height: tableHeight, width: "100%" }}>
            <ServerPaginationGridNoRowCount
              setPaginationModals={setPaginationModals}
              paginationModals={paginationModals}
              rowsData={candidates && candidates.rows ? candidates.rows : []}
              total={candidates && candidates.count ? candidates.count : 0}
              columns={columns}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: "apct_match_rate",
                      sort: "desc",
                    },
                  ],
                },
              }}
              setSortModels={setSortModels}
              sortModels={sortModels}
            />
          </div>
        </CardContent>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  candidates: state.candidate.candidateBatchLists,
  applicant_resume: state.applicant.applicant_resume,
  applicant_video: state.applicant.applicant_video,
});

const mapDispatchToProps = {
  sendInvite,
  addHrRemarks,
  getCandidatesByBatchId,
  releaseOffer,
  getApplicantReport,
  viewApplicantReport,
  scheduleSecRound,
};


const CandidatesBatch = (props) => {
  const SITE_KEY = "6LfJRwcrAAAAAGZX_9MG1m7EsJHMEsn-OZeQ7Oha";

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
      onLoad={() => console.log("reCAPTCHA loaded")}
      onError={(error) => console.error("reCAPTCHA loading error:", error)}
    >
      <CandidatesBatchComponent {...props} />
    </GoogleReCaptchaProvider>
  );
};

// const CandidatesBatch = connect(
//   mapStateToProps,
//   mapDispatchToProps
// )((props) => (
//   <GoogleReCaptchaProvider
//     reCaptchaKey="6LezPgcrAAAAAPjvpt7l1mOEoOJKFSYLEBX3Fo6a"
//     scriptProps={{
//       async: true,
//       defer: true,
//       appendTo: "head",
//     }}
//     onLoad={() => console.log("reCAPTCHA loaded")}
//     onError={(error) => console.error("reCAPTCHA loading error:", error)}
//   >
//     <CandidatesBatchComponent {...props} />
//   </GoogleReCaptchaProvider>
// ));
export default connect(mapStateToProps, mapDispatchToProps)(CandidatesBatch);
